import PageTitleComponent from "../../components/PageTitleComponent/PageTitleComponent";
import "./HomePage.scss"
import "../AboutPage/AboutPage.scss"
import SidebarComponent from "../../components/SidebarComponent/SidebarComponent";
import React, {useState, useEffect} from "react";
import FooterComponent from "../../components/FooterComponent/FooterComponent";

const HomePage = (colourClassName) => {
    const titleClassName = colourClassName + "Title";
 
    return (
        <div className={`homePage home-${colourClassName.colourClassName}`}>
            <main className="homeContainer" aria-label="Home Page Content">
                <SidebarComponent colourClassName={colourClassName}/>
                <section className="homeContent">
                    <PageTitleComponent colourClassName={titleClassName}/>
                    <FooterComponent colourClassName={colourClassName.colourClassName} aria-label="Home Page Footer"/>
                </section>
            </main>
        </div>
    );
};

export default HomePage;

